import { FunctionComponent } from 'react'

type SwitchProps = {
	label: string
	checked: boolean
	onChange: (value: boolean) => void
}

const Switch: FunctionComponent<SwitchProps> = props => {
	const { onChange, checked, label } = props
	return (
		<div className="switch">
			<label>{label}</label>
			<label className="switch__control">
				<input
					tabIndex={-1}
					type="checkbox"
					id="settings__highcontrast"
					checked={checked}
					onChange={e => onChange(e.currentTarget.checked)}
				/>
				<span className="switch__slider" />
			</label>
		</div>
	)
}

export default Switch
